module.exports = __webpack_public_path__ + "nebular.25116a35e5d6e6e2e4fa.ttf";


//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/nebular-icons/fonts/nebular.ttf?jaecku
// module id = ../../../../nebular-icons/fonts/nebular.ttf?jaecku
// module chunks = styles